import {PostPaymantPawapayAction, PostPaymantPawapayActionTypes, PostPaymantPawapayState} from "../../types/Payments/postPaymentPawapayTypes";

const initialState: PostPaymantPawapayState = {
    postPawapayData: {},
    loading: false,
    postPawapayErrorDara: null,
};

export const postPawapayReducer = (state = initialState, action: PostPaymantPawapayAction): PostPaymantPawapayState => {
    switch (action.type) {
        case PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA:
            return { ...state, loading: true, postPawapayErrorDara: null, postPawapayData: {} };
        case PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_SUCCESS:
            return { ...state, loading: false, postPawapayErrorDara: null, postPawapayData: action.payload };
        case PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_ERROR:
            return { ...state, loading: false, postPawapayErrorDara: action.payload, postPawapayData: {} };
        default:
            return state;
    }
};
